import React from 'react';
import { PlanSpaces } from '../../../../components/service/subscription/space/templates/PlanSpaces';
export const SubscribedSpacesPageView = () => {
  return <PlanSpaces data-sentry-element="PlanSpaces" data-sentry-component="SubscribedSpacesPageView" data-sentry-source-file="subscribed-spaces.tsx" />;
};